import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { calculateTimeDifference } from "@/modules/chats/lib/format-chat-time-duration"

type ChatMessageTimeAgoProps = {
  sendMessageDate: Date
}

const ChatMessageTimeAgo = (props: ChatMessageTimeAgoProps) => {
  const { sendMessageDate } = props
  const translation = useTranslation()
  const [timeAgo, setTimeAgo] = useState("")

  useEffect(() => {
    const calculateTimeAgo = () => {
      const currentTime = new Date().getTime()
      const messageTime = new Date(sendMessageDate).getTime()
      setTimeAgo(calculateTimeDifference(currentTime, messageTime, sendMessageDate, translation))
    }
    calculateTimeAgo()
    // Update time after 1 minutes
    const interval = setInterval(() => {
      calculateTimeAgo()
    }, 60000)
    // Clear interval after component unmount
    return () => clearInterval(interval)
  }, [sendMessageDate, translation])

  return <span className="flex shrink-0 text-xs">{timeAgo}</span>
}

export { ChatMessageTimeAgo }
